import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simular envío
    await new Promise(resolve => setTimeout(resolve, 1500));

    setIsSubmitting(false);
    setShowSuccess(true);

    // Resetear formulario después de 3 segundos
    setTimeout(() => {
      setShowSuccess(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    }, 3000);
  };

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://sunandspeed.com/wp-content/uploads/2025/04/1.webp"
            alt="Contact Us"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70"></div>
        </div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-4">
            <span className="text-amber-400">Contáctanos</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Estamos aquí para ayudarte. Disponibles 24/7 para responder todas tus preguntas
          </p>
        </div>
      </section>

      <div className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div>
              <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
                <h2 className="text-3xl font-bold text-white mb-6">
                  Envíanos un Mensaje
                </h2>

                {showSuccess ? (
                  <div className="bg-green-500/20 border border-green-500/50 rounded-lg p-6 text-center">
                    <i className="ri-check-line text-5xl text-green-400 mb-4"></i>
                    <h3 className="text-xl font-bold text-white mb-2">
                      ¡Mensaje Enviado!
                    </h3>
                    <p className="text-gray-300">
                      Gracias por contactarnos. Te responderemos pronto.
                    </p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-400 mb-2">
                        Nombre Completo *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full bg-black border border-amber-900/30 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-amber-500"
                        placeholder="Juan Pérez"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-400 mb-2">
                        Email *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full bg-black border border-amber-900/30 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-amber-500"
                        placeholder="juan@ejemplo.com"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-400 mb-2">
                        Teléfono *
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required
                        className="w-full bg-black border border-amber-900/30 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-amber-500"
                        placeholder="+52 998 123 4567"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-400 mb-2">
                        Asunto *
                      </label>
                      <select
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                        className="w-full bg-black border border-amber-900/30 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-amber-500 cursor-pointer"
                      >
                        <option value="">Selecciona un asunto</option>
                        <option value="reserva">Consulta sobre Reserva</option>
                        <option value="vehiculo">Información de Vehículo</option>
                        <option value="precio">Consulta de Precios</option>
                        <option value="modificacion">Modificar Reserva</option>
                        <option value="cancelacion">Cancelación</option>
                        <option value="otro">Otro</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-400 mb-2">
                        Mensaje *
                      </label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                        rows={6}
                        maxLength={500}
                        className="w-full bg-black border border-amber-900/30 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-amber-500 resize-none"
                        placeholder="Cuéntanos cómo podemos ayudarte..."
                      ></textarea>
                      <p className="text-xs text-gray-500 mt-1">
                        {formData.message.length}/500 caracteres
                      </p>
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full bg-gradient-to-r from-amber-500 to-amber-600 text-black py-4 rounded-full font-bold hover:from-amber-600 hover:to-amber-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                    >
                      {isSubmitting ? (
                        <span className="flex items-center justify-center gap-2">
                          <i className="ri-loader-4-line animate-spin"></i>
                          Enviando...
                        </span>
                      ) : (
                        'Enviar Mensaje'
                      )}
                    </button>
                  </form>
                )}
              </div>
            </div>

            {/* Contact Information */}
            <div className="space-y-8">
              {/* Quick Contact */}
              <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
                <h3 className="text-2xl font-bold text-white mb-6">
                  Contacto Directo
                </h3>

                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-2xl text-amber-400"></i>
                    </div>
                    <div>
                      <p className="text-gray-400 text-sm mb-1">Teléfono</p>
                      <a
                        href="tel:+522291578562"
                        className="text-white text-lg font-semibold hover:text-amber-400 transition-colors cursor-pointer"
                      >
                        +52 229 157 8562
                      </a>
                      <p className="text-gray-500 text-sm mt-1">Disponible 24/7</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-2xl text-amber-400"></i>
                    </div>
                    <div>
                      <p className="text-gray-400 text-sm mb-1">Email</p>
                      <a
                        href="mailto:info@vipluxurycarsmks.com"
                        className="text-white text-lg font-semibold hover:text-amber-400 transition-colors cursor-pointer"
                      >
                        info@vipluxurycarsmks.com
                      </a>
                      <p className="text-gray-500 text-sm mt-1">Respuesta en 24 horas</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-whatsapp-line text-2xl text-green-400"></i>
                    </div>
                    <div>
                      <p className="text-gray-400 text-sm mb-1">WhatsApp</p>
                      <a
                        href="https://wa.me/522291578562?text=Hola!%20Me%20comunico%20desde%20el%20sitio%20web%20de%20VIP%20Luxury%20Cars%20MKS.%20Tengo%20una%20consulta%20sobre%20sus%20servicios%2C%20%C2%BFpueden%20ayudarme%3F"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white text-lg font-semibold hover:text-green-400 transition-colors cursor-pointer"
                      >
                        +52 229 157 8562
                      </a>
                      <p className="text-gray-500 text-sm mt-1">Respuesta inmediata</p>
                    </div>
                  </div>
                </div>

                <div className="mt-8 pt-8 border-t border-amber-900/30">
                  <a
                    href="https://wa.me/522291578562?text=Hola,%20necesito%20información"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full bg-green-500 text-white py-4 rounded-full font-bold hover:bg-green-600 transition-all text-center whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-xl mr-2"></i>
                    Chatear por WhatsApp
                  </a>
                </div>
              </div>

              {/* Locations */}
              <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
                <h3 className="text-2xl font-bold text-white mb-6">
                  Nuestras Oficinas
                </h3>

                <div className="space-y-6">
                  <div>
                    <div className="flex items-center gap-2 mb-3">
                      <i className="ri-map-pin-line text-amber-400 text-xl"></i>
                      <h4 className="text-lg font-bold text-white">México</h4>
                    </div>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      Blvd. Kukulcan Km 16.4<br />
                      Zona Hotelera, 77500<br />
                      Cancún, Quintana Roo, México<br />
                      <span className="text-gray-500 text-xs">También en Playa del Carmen y Tulum</span>
                    </p>
                  </div>

                  <div className="border-t border-amber-900/30 pt-6">
                    <div className="flex items-center gap-2 mb-3">
                      <i className="ri-map-pin-line text-amber-400 text-xl"></i>
                      <h4 className="text-lg font-bold text-white">Estados Unidos</h4>
                    </div>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      Miami, Florida<br />
                      Aeropuerto Internacional y Miami Beach<br />
                      Servicio en toda Florida
                    </p>
                  </div>
                </div>
              </div>

              {/* Business Hours */}
              <div className="bg-gradient-to-br from-amber-900/20 to-amber-800/10 rounded-2xl p-8 border border-amber-700/30">
                <h3 className="text-2xl font-bold text-white mb-6">
                  Horario de Atención
                </h3>

                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-300">Lunes - Viernes</span>
                    <span className="text-white font-semibold">24 Horas</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-300">Sábado - Domingo</span>
                    <span className="text-white font-semibold">24 Horas</span>
                  </div>
                  <div className="flex justify-between items-center pt-3 border-t border-amber-700/30">
                    <span className="text-gray-300">Emergencias</span>
                    <span className="text-amber-400 font-bold">24/7</span>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-amber-700/30">
                  <div className="flex items-center gap-2 text-sm text-gray-300">
                    <i className="ri-customer-service-2-line text-amber-400"></i>
                    <span>Asistencia en carretera disponible las 24 horas</span>
                  </div>
                </div>
              </div>

              {/* Social Media */}
              <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
                <h3 className="text-2xl font-bold text-white mb-6">
                  Síguenos
                </h3>

                <div className="flex gap-4">
                  <a
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center hover:bg-amber-500 transition-all cursor-pointer"
                  >
                    <i className="ri-facebook-fill text-xl text-white"></i>
                  </a>
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center hover:bg-amber-500 transition-all cursor-pointer"
                  >
                    <i className="ri-instagram-line text-xl text-white"></i>
                  </a>
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center hover:bg-amber-500 transition-all cursor-pointer"
                  >
                    <i className="ri-twitter-x-line text-xl text-white"></i>
                  </a>
                  <a
                    href="https://tiktok.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center hover:bg-amber-500 transition-all cursor-pointer"
                  >
                    <i className="ri-tiktok-line text-xl text-white"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Map Section */}
          <div className="mt-16">
            <h2 className="text-3xl font-bold text-white mb-8 text-center">
              Encuéntranos
            </h2>
            <div className="bg-gray-900 rounded-2xl overflow-hidden border border-amber-900/30">
              <iframe
                src="https://maps.google.com/maps?q=Blvd.+Kukulcan+Km+16.4,+Zona+Hotelera,+77500+Cancun+Quintana+Roo,+Mexico&output=embed&z=16"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación de Sun & Speed"
              ></iframe>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="mt-16">
            <h2 className="text-3xl font-bold text-white mb-8 text-center">
              Preguntas Frecuentes
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gray-900 rounded-xl p-6 border border-amber-900/30">
                <h4 className="text-lg font-bold text-amber-400 mb-3">
                  ¿Cuál es la edad mínima para alquilar?
                </h4>
                <p className="text-gray-300 text-sm">
                  La edad mínima es de 25 años con licencia de conducir válida de al menos 3 años de antigüedad.
                </p>
              </div>

              <div className="bg-gray-900 rounded-xl p-6 border border-amber-900/30">
                <h4 className="text-lg font-bold text-amber-400 mb-3">
                  ¿Qué documentos necesito?
                </h4>
                <p className="text-gray-300 text-sm">
                  Licencia de conducir, identificación oficial, tarjeta de crédito y comprobante de domicilio.
                </p>
              </div>

              <div className="bg-gray-900 rounded-xl p-6 border border-amber-900/30">
                <h4 className="text-lg font-bold text-amber-400 mb-3">
                  ¿Incluye seguro?
                </h4>
                <p className="text-gray-300 text-sm">
                  Sí, todos nuestros alquileres incluyen seguro de cobertura completa y asistencia en carretera 24/7.
                </p>
              </div>

              <div className="bg-gray-900 rounded-xl p-6 border border-amber-900/30">
                <h4 className="text-lg font-bold text-amber-400 mb-3">
                  ¿Puedo cancelar mi reserva?
                </h4>
                <p className="text-gray-300 text-sm">
                  Sí, ofrecemos cancelación flexible. Consulta nuestra política de cancelación para más detalles.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}